import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';

import { Heading, NamedLink, InlineTextButton } from '../../components';

import css from './AuthenticationPage.module.css';

const EmailVerificationInfo = props => {
  const {
    name,
    email,
    onResendVerificationEmail,
    resendErrorMessage,
    sendVerificationEmailInProgress,
    onClose,
  } = props;

  const resendEmailLink = (
    <InlineTextButton
      rootClassName={css.modalHelperButton}
      onClick={onResendVerificationEmail}
      inProgress={sendVerificationEmailInProgress}
      disabled={sendVerificationEmailInProgress}
    >
      <FormattedMessage id="AuthenticationPage.resendEmailLinkText" />
    </InlineTextButton>
  );

  const cancelButton = (
    <InlineTextButton rootClassName={css.modalCancelButton} onClick={onClose}>
      Abbrechen
    </InlineTextButton>
  );

  const fixEmailLink = (
    <NamedLink className={css.modalHelperLink} name="ContactPage">
      <FormattedMessage id="AuthenticationPage.fixEmailLinkText" />
    </NamedLink>
  );

  return (
    <div className={css.content}>
      <Heading as="h1" rootClassName={css.modalTitle}>
        <FormattedMessage id="AuthenticationPage.verifyEmailTitle" values={{ name }} />
      </Heading>
      <p className={css.modalMessage}>
        <FormattedMessage id="AuthenticationPage.verifyEmailText" values={{ email: <strong>{email}</strong> }} />
      </p>
      {resendErrorMessage}

      <div className={css.bottomWrapper}>
        <p className={css.modalHelperText}>
          <FormattedMessage id="AuthenticationPage.fixEmail" values={{ fixEmailLink }} />
        </p>
        <p className={css.modalButtons}>
          {onClose ? cancelButton : null}
          {resendEmailLink}
        </p>
      </div>
    </div>
  );
};

export default EmailVerificationInfo;
